// @flow

import * as React from 'react';
import compose from 'lodash/fp/compose';
import prop from 'lodash/fp/prop';
import Container from 'components/Container/Container';
import { splitLong } from 'services/format/splitDate';
import L10nMessage from 'react-aaui/lib/shared/L10nMessage';
import AddressStatic from 'react-aaui/lib/form/AddressStatic';
import toUIAddress from '@active/awe-ui-core/lib/dataTransfer/address';
import Maybe, { maybe } from '@active/awe-ui-core/lib/fp/Maybe';
import EllipsisDisplay from '@active/awe-ui-core/lib/components/EllipsisDisplay';
import Row from 'react-aaui/lib/grid/Row';
import Col from 'react-aaui/lib/grid/Col';
import type { Event } from 'type/type';
import Responsive from 'react-responsive';

import defaultLogo from './event_logo_active.png';
import './EventProfile.scss';

type Props = {
  raceEvent?: ?Event,
  locale: string
}

const EVENT_NAME_HEIGHT = 40;
const EVENT_NAME_LINE_HEIGHT = 1.08;
const EVENT_NAME_LINE_TO_SHOW = 2;
const TABLET_EVENT_NANE_HEIGHT = 24;
const MOBILE_EVENT_NAME_HEIGHT = 18;

const EventProfile = ({ raceEvent, locale }: Props) => {
  const evt = Maybe.of(raceEvent);
  const date = maybe(null, e => splitLong(e.startDate, e.timeZone, locale), evt);
  const address = maybe(null, compose(toUIAddress, prop('address')), evt);
  return (
    <Container className="event-header__event-profile">
      <div className="event-header__wrapper">
        {
          maybe(null, event => (
            <Row>
              <Col className="event-header__info" span={9}>
                <Responsive minWidth={1200}>
                  <EllipsisDisplay
                    className="event-name"
                    content={event.name}
                    contentHeight={EVENT_NAME_HEIGHT * EVENT_NAME_LINE_HEIGHT * EVENT_NAME_LINE_TO_SHOW} />
                </Responsive>

                <Responsive maxWidth={1199} minWidth={768}>
                  <EllipsisDisplay
                    className="event-name"
                    content={event.name}
                    contentHeight={TABLET_EVENT_NANE_HEIGHT * EVENT_NAME_LINE_HEIGHT * EVENT_NAME_LINE_TO_SHOW} />
                </Responsive>

                <Responsive maxWidth={767}>
                  <EllipsisDisplay
                    className="event-name"
                    content={event.name}
                    contentHeight={MOBILE_EVENT_NAME_HEIGHT * EVENT_NAME_LINE_HEIGHT * EVENT_NAME_LINE_TO_SHOW} />
                </Responsive>

                { !event.isVirtual && <div className="event-address font-l">
                  <AddressStatic address={address} locale={locale} nowrap />
                </div> }

                <div className="space" />

                <div>
                  <div className="event-date">
                    <div className="day">{date.day}</div>
                    <div className="month-and-year font-m">
                      <div>{date.month}</div>
                      <div>{date.year}</div>
                    </div>
                  </div>
                </div>

                <div className="powered-by font-s">
                  <L10nMessage id="powered.by" />
                </div>
              </Col>

              <Col span={3}>
                <div className="event-logo">
                  <img src={event.logo || defaultLogo} alt="" />
                </div>
              </Col>
            </Row>
          ), evt)
        }
      </div>
    </Container>
  );
};

EventProfile.defaultProps = {
  raceEvent: null,
};

export default EventProfile;
